export default {
  computed: {
    favoritesLength() {
      let favorites = [];

      if (this.favorites && this.favorites.length > 0) {
        this.favorites.forEach((album) => {
          if (this.album && album.albumId === this.album.id) {
            album.items.forEach((photo) => {
              favorites.push(photo);
            });
          }
        });
      }

      return favorites.length;
    },
    helperMySelectionStep1() {
      return this.$store.getters.HELPER_MY_SELECTION_STEP_1;
    },
    helperMySelectionStep2() {
      return this.$store.getters.HELPER_MY_SELECTION_STEP_2;
    },
  },
  methods: {
    setMySelectionHelperStep(step) {
      localStorage.setItem(`my-selection-${step}`, '1');

      switch (step) {
        case 'step-1':
          this.$store.dispatch('SET_HELPER_MY_SELECTION_STEP_1', true);
          break;
        case 'step-2':
          this.$store.dispatch('SET_HELPER_MY_SELECTION_STEP_2', true);
      }
    }
  }
};
